import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Home as HomeIcon, Map } from "lucide-react";

export default function SuccessTori() {
  return (
    <div className="max-w-[700px] mx-auto w-full px-6 py-24 text-center">
      <div className="w-20 h-20 rounded-full bg-[#E8F5E9] flex items-center justify-center mx-auto">
        <CheckCircle2 size={44} className="text-[#1B6B2E]" />
      </div>
      <h1 className="text-4xl sm:text-5xl font-[700] text-[#0D3B4C] tracking-tight mt-6" data-testid="success-title">
        Bedankt voor je Tori!
      </h1>
      <p className="mt-4 text-lg font-[400] text-[#0D3B4C]">
        Je verhaal is goed ontvangen. We bekijken het even voordat het live gaat op de kaart.
        Zodra het is goedgekeurd, verschijnt het bij <span className="font-[600]">Verhalen</span>.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
        <Link
          to="/deel-jouw-tori"
          data-testid="success-another"
          className="w-full sm:w-auto bg-[#B71C1C] text-white font-[700] uppercase tracking-wider py-4 px-8 hover:bg-[#8E1515] transition-colors"
        >
          Nog een Tori delen
        </Link>
        <Link
          to="/verhalen"
          data-testid="success-stories"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#1B6B2E] text-white font-[700] uppercase tracking-wider py-4 px-8 hover:bg-[#144F22] transition-colors"
        >
          <Map size={18} /> Bekijk verhalen
        </Link>
        <Link
          to="/"
          data-testid="success-home"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 font-[700] text-[#0D3B4C] py-4 px-4 hover:text-[#1B6B2E] transition-colors"
        >
          <HomeIcon size={18} /> Naar home
        </Link>
      </div>
    </div>
  );
}
